/**
 * Runtime singletons the HTTP layer needs (Vue router + Vuex store).
 *
 * `_axios.js` must NOT statically import `../router` or `../store`. The router
 * eagerly imports every route view, and views import API modules, so a static
 * import here turns `src/api/*` into a dependency of the whole app graph. That
 * is what made Jest's `--findRelatedTests` treat almost every suite as related
 * to any API change (e.g. 211 suites for `askIQApi.js`).
 *
 * The router and store register themselves below instead, so `src/api/*` stays
 * a leaf of the dependency graph. Consumers must handle `null` (e.g. before the
 * app has bootstrapped, or in unit tests that only import an API module).
 */
let router = null;
let store = null;

export const registerApiRuntimeDeps = (deps = {}) => {
  if (deps.router) router = deps.router;
  if (deps.store) store = deps.store;
};

export const getRouter = () => router;
export const getStore = () => store;
